import React, { useState } from "react";
import {
  Switch,
  Dialog,
  Button,
  ButtonOwnProps,
  SwitchProps,
  Container,
  Box,
  Grid,
  DialogContentText,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

import conf from "config-dlm";
import SectionHeader from "components/utils/SectionHeader";

type SwitchWithConfirmProps = {
  type: string;
  size?: SwitchProps["size"];
  color?: ButtonOwnProps["color"];
  message: string | JSX.Element;
  variant?: ButtonOwnProps["variant"];
  disabled?: boolean;
  onConfirm: () => void;
  showButton?: boolean;
  defaultOpen?: boolean;
  defaultChecked?: boolean;
};
const SwitchWithConfirm = (props: SwitchWithConfirmProps) => {
  const { type, message, onConfirm } = props;
  const { size = "medium", defaultChecked } = props;

  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(defaultChecked);

  const handleOn = () => {};
  const handleOff = () => setOpen(true);
  const cancelOff = () => setOpen(false);
  const confirmOff = () => {
    onConfirm();
    setOpen(false);
    setChecked(false);
  };

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setChecked(true);
      handleOn(); // call function when switched on
    } else {
      handleOff(); // open confirmation modal when switching off
    }
  };

  return (
    <div>
      <Switch
        size={size}
        color={checked ? "success" : "error"}
        checked={checked}
        onChange={handleToggle}
      />

      <Dialog maxWidth="md" fullWidth open={open} onClose={cancelOff}>
        <Container component="main" sx={conf.STYLE.DIALOG}>
          <SectionHeader
            key={`${type}-confirmation-switch`}
            icon={<WarningIcon />}
            title={`Confirm: ${type.toUpperCase()}`}
            buttons={[
              <Button
                key={"confirmation-switch-close"}
                color="inherit"
                variant="outlined"
                onClick={cancelOff}
              >
                <CloseIcon />
              </Button>,
            ]}
          />

          <Box component="form" noValidate>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container p={1} mt={1} border={1} borderRadius={1}>
                  <DialogContentText>{message}</DialogContentText>
                </Grid>
              </Grid>
            </Grid>

            <Stack
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              sx={{ mt: 2, mb: 2 }}
            >
              <Button variant="outlined" onClick={cancelOff}>
                Cancel
              </Button>

              <Button variant="contained" onClick={confirmOff}>
                Confirm
              </Button>
            </Stack>
          </Box>
        </Container>
      </Dialog>
    </div>
  );
};

export default SwitchWithConfirm;
